import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import useStylesFacebook from './styles'
import { Container } from '@material-ui/core';

const Progress = () => {
    const classes = useStylesFacebook();

    return (
        <Container className={classes.container}>
            <CircularProgress
                // color="secondary"
                className={classes.bottom}
            />
        </Container>
    );
}

export default Progress;
